'use client';

import { MouseEvent, useEffect, useState } from 'react';
import { DEFAULT_IMAGE } from 'constants/common';
import { Image } from 'components/image';
import Link from 'next/link';
import { getFormattedSearchSelectItem, getPDPUrl } from './utils';
import { useParams } from 'next/navigation';
import { ProductCardTitleProps } from './product-card-title';
import { useSelectItemEvent } from 'hooks/analytics/use-select-item-event';

export interface ProductCardThumbnailProps {
  imgSrc: string;
  width?: number;
  height?: number;
  serialNumber?: string;
  fitmentCheck?: string;
}

const ProductCardThumbnail = ({
  imgSrc,
  productName,
  productNumber,
  href,
  productPriceData,
  isHeadlessPDPEnabled,
  orderItem,
  locationId,
  width = 160,
  height = 160,
  serialNumber,
  fitmentCheck
}: ProductCardThumbnailProps & ProductCardTitleProps) => {
  const esiteParams = useParams();
  const imgParams = `wid=${width}&hei=${height}&fmt=webp`;
  const [imgSrce, setImgSrce] = useState(`${imgSrc}?${imgParams}`);
  const { fireEvent: fireSelectItemEvent } = useSelectItemEvent();

  const pdpURL = getPDPUrl({
    esiteParams,
    isHeadlessPDPEnabled,
    productNumber,
    productURL: href
  });

  const loaderMap = ({ src }) => {
    return src;
  };

  useEffect(() => {
    setImgSrce(`${imgSrc}?${imgParams}`);
  }, [imgParams, imgSrc]);

  const handleClick = (e: MouseEvent) => {
    if (!isHeadlessPDPEnabled) {
      e.preventDefault();
      window.location.href = pdpURL;
    }

    productPriceData &&
      fireSelectItemEvent({
        item: getFormattedSearchSelectItem(orderItem, productPriceData),
        partName:
          productPriceData &&
          `${productPriceData?.partNumber}: ${productPriceData?.name}`,
        locationId,
        itemSummary: {
          categoryPath: productPriceData?.productPriceData?.categoryPath,
          manufacturer: productPriceData?.manufacturer
        },
        isSearchPageEvent: true,
        itemListId: productPriceData?.listNameAndId,
        itemListName: productPriceData?.listNameAndId,
        index: productPriceData.index,
        serialNumber,
        fitment: fitmentCheck
      });
  };

  return (
    <div className="d-flex justify-content-center ps-1 ps-md-0">
      <Link key={pdpURL} href={pdpURL} onClick={handleClick}>
        <Image
          loading="lazy"
          alt={`${productNumber}: ${productName}`}
          src={imgSrce}
          width={width}
          height={height}
          loader={loaderMap}
          onError={() => {
            setImgSrce(`${DEFAULT_IMAGE}?${imgParams}`);
          }}
        />
      </Link>
    </div>
  );
};

export default ProductCardThumbnail;
